import {useState} from "react";
import {useSelector} from "react-redux";
import {selectUserId} from "../../store/features/Auth/authSlice.ts";
import {buildQueryParams} from "../../utilis/buildQueryParams.ts";
import {PhoneHQAvatar} from 'ch3-ui-lib';
import {useFetchUsersQuery, User} from "../../store/features/Users/userService.ts";

interface UseUsersFiltersProps {
    selectedUsers: User[];
    setSelectedUsers: (users: User[]) => void;
    admin?: boolean;
}

interface UsersFiltersReturn {
    usersPhrase: string;
    setUsersPhrase: (phrase: string) => void;
    users: any[];
    handleUserSelect: (value: any) => void;
    isLoading?: boolean;
    error?: any;
}

export const useUsersFilter = ({
                                   selectedUsers,
                                   setSelectedUsers,
                                   admin = false
                               }: UseUsersFiltersProps): UsersFiltersReturn => {
    const [usersPhrase, setUsersPhrase] = useState<string>('');
    const userId = useSelector(selectUserId);

    const userQueryParams = buildQueryParams({
        phrase: usersPhrase,
        userId: admin ? undefined : userId, // If admin, don't filter by userId
    });
    const {data: usersData = [], isLoading, error} = useFetchUsersQuery(userQueryParams);

    const users = usersData?.length ? usersData?.map((user) => ({
        key: `user${user?.id}`,
        label: user.firstName + ' ' + user.lastName,
        value: user,
        prefixElement: <div ><PhoneHQAvatar className='!w-6' src={user.avatarUrl} name={user.firstName + ' ' + user.lastName} size="24px"/></div>,
    })) : [];

    const handleUserSelect = (value: any) => {
        const exists = selectedUsers.some(user => user.id === value.id);

        const newSelectedUsers = exists
            ? selectedUsers.filter(user => user.id !== value.id)
            : [...selectedUsers, value];
        setSelectedUsers(newSelectedUsers);
    };

    return {
        usersPhrase,
        setUsersPhrase,
        users,
        handleUserSelect,
        isLoading,
        error,
    };
};